/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/authSamlServiceView.html';

class AuthSAMLServiceView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.template = opts.template || Template;
		super(opts);

		this.model.get('type') === 'saml'
			? this.el.classList.add('nx-saml')
			: this.el.classList.add('nx-standard');
	}

	/** @type {string} */
	static get __name__() {
		return 'AuthSAMLServiceView';
	}
}

export default AuthSAMLServiceView;
